import React, { useCallback, useEffect, useState } from "react";
import { useAlert } from "../../../context/AlertProvider";
import { useHasPermission } from "../../../hooks/useHasPermission";
import {
  useGetClinicModulesMutation,
  useUpdateClinicModulesMutation,
} from "../../../store/clinicApi";
import ClinicModulesPanel from "../../../components/organisms/ClinicModulesPanel";

// Admin → Klinik detayı → Modüller: profil, izin verilen (satılan) modüller, terim seti.
export default function ModulesTab({ clinicId, token, palette, onSave }) {
  const { showSuccess, showError } = useAlert();
  const canEdit = useHasPermission("admin-clinics:update-work-type");
  const [getModules, { isLoading }] = useGetClinicModulesMutation();
  const [updateModules, { isLoading: saving }] = useUpdateClinicModulesMutation();
  const [modules, setModules] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await getModules({ token, clinicId }).unwrap();
      setModules(r?.data?.modules || null);
    } catch (e) {
      showError(e?.data?.message || "Modüller yüklenemedi");
    }
  }, [getModules, token, clinicId, showError]);

  useEffect(() => {
    if (token && clinicId) load();
  }, [token, clinicId, load]);

  const handleSave = async (payload) => {
    try {
      const r = await updateModules({ token, clinicId, ...payload }).unwrap();
      setModules(r?.data?.modules || null);
      showSuccess("Modüller güncellendi");
      onSave?.();
    } catch (e) {
      showError(e?.data?.message || "Modüller güncellenemedi");
    }
  };

  return (
    <ClinicModulesPanel
      mode="admin"
      modules={modules}
      loading={isLoading && !modules}
      saving={saving}
      canEdit={canEdit}
      palette={palette}
      onSave={handleSave}
    />
  );
}
